<template>
  <nav class=" bg-white shadow-xl w-full flex relative justify-between items-center mx-auto px-8 py-12 h-20">
    <div class="inline-flex">
        <router-link to="/">
          <img class="w-48" src="../assets/logoNavbar.png">
        </router-link>
    </div>

    <div class="flex-initial font-sans font-extrabold">
      <div class="flex justify-end items-center relative">
        <div class="flex mr-4 items-center">
            <router-link to='/'>Home</router-link>
        </div>
        <div class="flex mr-4 items-center">
            <router-link to='/exhibition-hall'>Exhibition Hall</router-link>
        </div>
        <div class="flex mr-4 items-center">
            <router-link to='/tenant-list'>Tenant List</router-link>
        </div>
        <div class="flex mr-4 items-center">
            <router-link to='/events'>Events</router-link>
        </div>
        <div class="flex mr-4 items-center">
            <router-link to='/tutorial'>Tutorial</router-link>
        </div>
        <div class="flex mr-4 items-center">
            <router-link to='/games'>Games</router-link>
        </div>
        <div class="flex mr-4 items-center">
            <router-link to='/register'>Register</router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>

<style>

</style>
